
import { AsyncThunk, AsyncThunkConfig, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchByIdFactory } from "./fetchByIdFactory";
import { ANIMAL_EVENT, AnimalEventResponse } from "../../Services/Agrisys_GqlDataCaller/EventsDataCalls/GQLCalls/getEvents";
import { AnimalEventInfo } from "../../Services/Agrisys_GqlDataCaller/EventsDataCalls/eventsSlice";

  
export const fetchEventsByAnimalIdsThunk = createAsyncThunk(
  `events/fetchByAnimalIds`,
  fetchByIdFactory<AnimalEventResponse, AnimalEventInfo>(ANIMAL_EVENT, (animal) => animal.data.animal.info.flatMap(({animal_id, event}) => event.map((e) =>({...e, animal_id}))))
) satisfies AsyncThunk<AnimalEventInfo[], number[], AsyncThunkConfig> as AsyncThunk<AnimalEventInfo[], number[], AsyncThunkConfig>
// Explicit typing is required

